export type TextMarkKind = 'stretch' | 'cover' | 'use' | 'repeat' | 'combined';

// 划重点支持处理的 svg 路径类型
export const TextMarkSvgSupportPath = ['line', 'path', 'rect', 'use', 'circle', 'ellipse'];

/**
 * 文字划重点素材
 * type: stretch-长度拉伸;
 *       cover-拉伸填充;
 *       use-单字，需要对 svg 预先处理，参考三角形;
 *       repeat-重复;
 *       combined-拼接;
 */
export type TextMarkConfig = {
    type: TextMarkKind;
    sizeRange: number[];
    enableSize: boolean; // 是否可调整粗细
    enableOpacity: boolean; // 是否可调整透明度
    src: string;
    defaultColor: string;
    defaultFontSize: number;
    position: 'top' | 'bottom' | 'center';
    repeatPath?: string; // 重复的路径
    forceStretch?: boolean; // 强制拉伸, 仅对 path 有效。true: preserveAspectRatio 设置为 none，边缘的圆角会变形；false: 使用 svgPath 算法进行拉伸
    // 偏移量
    offset: {
        x: number;
        y: number;
    };
    // 延伸距离
    padding: {
        x: number;
        y: number;
    };
};

export type TextMarkStruct = {
    materialId: string;
    isVip?: boolean;
    data: TextMarkConfig;
    animate?: number;
    useBlackText?: number; // 缩略图强制黑色字
    thumbnail?: {
        width?: number;
        height?: number;
        url?: string;
    };
    thumbnailBlack?: {
        width?: number;
        height?: number;
        url?: string;
    };
};
